// extracted by mini-css-extract-plugin
export default {"content":"Integrity_content__Zqbhh","contentValue":"Integrity_contentValue__C8PdS"};